"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteGroceryItemsByRecipeMutationOptions = exports.deleteGroceryItemsByRecipeMutation = void 0;
const client_1 = require("@apollo/client");
const groceryItems_1 = require("../queries/groceryItems");
exports.deleteGroceryItemsByRecipeMutation = client_1.gql `
  mutation DeleteGroceryItemsByRecipe($recipeId: String!) {
    deleteGroceryItemsByRecipe(recipeId: $recipeId) {
      __typename
      ok
    }
  }
`;
exports.deleteGroceryItemsByRecipeMutationOptions = (variables) => ({
    variables,
    update: store => {
        const data = store.readQuery({
            query: groceryItems_1.groceryItemsQuery,
        });
        if (data) {
            store.writeQuery({
                query: groceryItems_1.groceryItemsQuery,
                data: {
                    __typename: "Query",
                    groceryItems: {
                        __typename: "GroceryItemsResponse",
                        items: data.groceryItems.items.filter(x => x.recipeId !== variables.recipeId),
                        recipes: data.groceryItems.recipes,
                    },
                },
            });
        }
    },
});
//# sourceMappingURL=DeleteGroceryItemsByRecipe.js.map